
import {AppLink as Link, AppWrapper} from "../components/helpers";
import { useEffect, useState } from "react";


function timeAgo(date) {
    const now = new Date();
  const pastDate = new Date(date);

  // Calculate IST time
  const nowIST = new Date(now.getTime() + (330 * 60 * 1000)); // IST is UTC+5:30, 330 minutes ahead of UTC
  const pastDateIST = new Date(pastDate.getTime() + (330 * 60 * 1000));

  const diffInMilliseconds = nowIST - pastDateIST; // Time difference in milliseconds
  const diffInMinutes = Math.floor(diffInMilliseconds / 1000 / 60); // Convert milliseconds to minutes

  if (diffInMinutes < 60) {
    // If less than 60 minutes
    return `${diffInMinutes} minutes ago`;
  } else {
    const diffInHours = Math.floor(diffInMinutes / 60); // Convert minutes to hours
    return `${diffInHours} hours ago`;
  }
  }

// A row arrives as { id, type, data, created_at }, where `data` is a JSON
// string holding one of two payloads:
//
//   a message   "client-loadManifest www.example.com, Cannot read properties…"
//   a call      { url, request: { method, appId, … }, response }
//
// Flatten both into one shape so the card renders without branching on which
// kind it got. Today's sample is 83 messages to 7 calls, so neither is an edge
// case. Nothing here throws: a payload that will not parse is kept as text.
function normalizeRow(row) {
    let payload = row.data;
    try { payload = JSON.parse(row.data); } catch (e) { /* already plain text */ }

    const call = payload && typeof payload === "object" ? payload : null;
    return {
        id: row.id,
        date: row.created_at,
        // Something short to head the card: the app it happened to, then the
        // endpoint, then the first clause of a message.
        // Rows do turn up with an empty payload (data:"\"\""), so fall back to
        // a label rather than heading the card with nothing.
        title: call
            ? ((call.request && call.request.appId) || call.url || "Unknown")
            : (String(payload).split(",")[0] || "(empty)"),
        message: call
            ? String(call.response === undefined ? "" : call.response)
            : String(payload),
        request: call ? call.request : null
    };
}



  
export default function Pages(props) {
    const [data, setData] = useState({
        app:[],
        pwa:[]
    });
    const [logs, setLogs] = useState([]);

    const [domain, setDomain] = useState({
        app:[],
        pwa:[]
    });


    useEffect(()=>{
        fetchLogs();
    }, [])

   const searchCache = function() {
    setDomain("react-app-demo1.pwastore.com")
    fetch("https://api-fetch.mediadirhub.com/logs/app-logs", {
        method:"POST",
        body:JSON.stringify({
            domain:"react-app-demo1.pwastore.com"
        })
    }).then(function(data){
        data.json().then(function(data){
            setData(data)
        })
    })
   }
   const fetchLogs = function() {
        const date = new Date();
        //date.setDate(date.getDate() - 1);
        const datePass = date.toISOString().split("T")[0];
        fetch("https://api-logs.mediadirhub.com/logs", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                method: "list",
                type: "pwa",
                date: datePass
            })
        }).then(function(res){
            res.json().then(function(response){
                // The service replies { success, data: [...] }. Accept a bare
                // array and a keyed object too, so this keeps working if the
                // envelope changes again.
                let rows = [];
                if (Array.isArray(response)) {
                    rows = response;
                } else if (response && Array.isArray(response.data)) {
                    rows = response.data;
                } else if (response && typeof response === "object") {
                    for (var k in response) rows.push(response[k]);
                }
                setLogs(rows.map(normalizeRow));
            })
        })
   }


   return <AppWrapper>
     <div className="container-fluid p-4 ">
         <h1>Total Failed ({logs.length})</h1>
     <div className="row p-2">
     {
             logs.map(function(v){
                 return  <div className="col-12" key={v.id}>
                 <div className="card w-100 mb-2">
    <div className="card-header">
        {v.title} ({timeAgo(v.date)}) <span className="badge bg-danger float-end">Failed</span>
    </div>
    <div className="card-body">
{v.request?<p>{JSON.stringify(v.request)}</p>:""}
{v.message}
    </div>

</div>
</div>

             })
         }
        
         </div>
         
        
     <div className="input-group input-group-lg p-1 d-none">
  <input type="text" className="form-control" placeholder="Search your domain" />
  <button className="btn btn-success" type="button" onClick={searchCache}>Search</button>
</div>
         <div className="row p-2 d-none">
         <div className="col-4 p-2">

         <ul className="list-group">
         <li className="list-group-item d-flex justify-content-between align-items-center bg-secondary text-white">
<div class="fw-bold">PWA Cache</div>

    </li>
             {
                 data.pwa.map(function(v){
                    return   <li className="list-group-item d-flex justify-content-between align-items-center">
                    {v.name.replace(`${domain}_`, "")}
                    <span className="badge bg-primary rounded-pill">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">
                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z"/>
                    </svg>
                    </span>
                  </li>
                 })
             }
       
  

 
</ul>

          
          </div>

          <div className="col-4 p-2">

<ul className="list-group">
<li className="list-group-item d-flex justify-content-between align-items-center bg-secondary text-white">
<div class="fw-bold">App Cache</div>

    </li>
    {
        data.app.map(function(v){
           return   <li className="list-group-item d-flex justify-content-between align-items-center">
           {v.name.replace(`${data.appId}_`, "")}
           <span className="badge bg-primary rounded-pill">
           <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check" viewBox="0 0 16 16">
           <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425z"/>
           </svg>
           </span>
         </li>
        })
    }




</ul>

 
 </div>
         
          
             </div>
         </div>
     
    </AppWrapper>
}